import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { GetPrepLessons } from '../../../typings';

interface GetPrepLessonsData {
    page: number;
    pageSize: number;
    themeId: number;
    showUnpublishedLessons?: boolean;
}

export function getPrepLessons({
   page,
   pageSize,
   themeId,
   showUnpublishedLessons
}: GetPrepLessonsData): Promise<GetPrepLessons> {
    const { apiGetPrepLessons } = apiConfig.getStaticUrls();

    return getFetch(apiGetPrepLessons, { page, pageSize, themeId, showUnpublishedLessons });
}
